import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { environment } from '../../../utility/environment';
import { api } from '../../../utility/service/api-base';
import { FormInput } from '../../../components/FormInput';
import iUser from '../../../assets/images/i_user.png';
import iPwd from '../../../assets/images/i_pwd.png';
import { Button } from 'primereact/button';

const Ldap = ({idpType="LDAP"}) => {
    const { t, i18n } = useTranslation();

    // const location = useLocation();
    const [title, setTitle] = useState('');
    const [imgSrc, setImgSrc] = useState('');
    // const [idpType, setIdpType] = useState('LDAP');

    const {
        register,
        handleSubmit,
        watch,
        getValues,
        setValue,
        control,
        formState: { errors }
    } = useForm({
        defaultValues: {
            username: '',
            password: ''
        },
        //錯誤驗證時機
        mode: 'onTouched'
    });


    useEffect(() => {
        getTitle();
        getIcon();
    }, [])

    const getTitle = () => {
        let tarUrl = '';

        if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
            tarUrl = environment.apiUrl;
        }
        else {
            tarUrl = `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;
        }
        tarUrl += `/dgrv4/ssotoken/acidp/${idpType}/getTitle`;

        api({ url: tarUrl, method: 'get', data: {} }).then(res => {
            // console.log(res.data)
            setTitle(res.data)
        })
    }

    const getIcon = () => {
        let tarUrl = '';

        if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
            tarUrl = environment.apiUrl;
        }
        else {
            tarUrl = `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;
        }
        tarUrl += `/dgrv4/ssotoken/acidp/${idpType}/getIcon`;

        api({ url: tarUrl, method: 'get', data: {} }).then(res => {
            // console.log(res.data)
            setImgSrc(res.data)
        })
    }

    const onSubmit = (data) => {
        // console.log('LDAP', data)

        const tarUrl = `${environment.apiUrl}/dgrv4/ssotoken/acidp/${idpType}/acIdPLogin`;

        let headers = {
            'Content-Type': `application/x-www-form-urlencoded`,
        }

        let formData = {
            'username': data.username,
            'password': data.password
        }

        api({ url: tarUrl, method: 'post', headers: headers, data: formData })
            .then(res => {
                // console.log(res)
                window.location.href = res.request.responseURL;
            })

    }



    return (
        <>
            <div className="container-fluid">
                <div className="row justify-content-center align-items-center">
                    <div className="col-lg-4 col-md-5 col-sm-6 col-xs-12" style={{ background: '', marginTop: '10vh' }}>
                        <div className="card w-100 h-100 border border-black center">
                            <div style={{ display: 'flex', wordBreak:'break-word' }}
                                className='flex justify-content-center align-items-center m-2 '>
                                <img src={imgSrc} alt="icon" />
                                <label style={{ fontWeight: 'bold' }}>
                                    {title}                                    
                                </label>
                            </div>
                            <hr className='mt-0'></hr>
                            <div className="line">
                                <label style={{ color: '#45BCB4', fontWeight: '600', fontSize: '24px' }}>{ idpType==='LDAP'?t('ldap_login'):t('mldap_login')}</label>
                                <br />
                                <label style={{ color: '#666666', fontWeight: '600', fontSize: '24px' }}>{t('continue_proc')} ESG</label>
                            </div>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="container justify-content-center col-12" >
                                    <div className="field">
                                        <FormInput
                                            layoutClass="login-input"
                                            register={register}
                                            errors={errors}
                                            id="username"
                                            labelText={t("account")}
                                            type="text"
                                            rules={{ required: t('user_name_required') }}
                                            placeholder={t("account")}
                                        />
                                    </div>
                                    <div className="field">
                                        <FormInput
                                            layoutClass="login-input"
                                            register={register}
                                            errors={errors}
                                            id="password"
                                            labelText={t("password")}
                                            type="password"
                                            rules={{ required: t('password_required') }}
                                            placeholder={t("password")}
                                        />
                                    </div>
                                    <div className="field text-center">
                                        <Button size="small" type="submit" label={t("login")} rounded/>
                                    </div>

                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Ldap